import {twMerge} from "tailwind-merge";
import {MenuList, MenuListClient} from "./Menu";
import MenuItem from "./MenuItem";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../../components/shared/Loader";
import {Navigate} from "react-router-dom";
import {userRoleList} from "../../../utils/constants";

const MenuListItems = ({className}) => {
  const {data, isLoading, isError} = useMe();
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <Navigate to={"/login"} replace />;
  }
  return (
    <div
      className={twMerge(
        " hidden  w-full lg:flex justify-center  items-center  h-full ",
        className
      )}
    >
      {data.selectedRole === userRoleList.TECHNICIAN
        ? !!MenuList.length &&
          MenuList.map((item) => <MenuItem key={item?.title} item={item} />)
        : !!MenuListClient.length &&
          MenuListClient.map((item) => (
            <MenuItem key={item?.title} item={item} />
          ))}
    </div>
  );
};

export default MenuListItems;
